
import {
  Vue,
  Component,
  Watch,
  Ref,
  Prop,
} from 'vue-property-decorator';
import {
  Dialog,
  Button,
  Row,
  Col,
  Form,
  FormItem,
  Input,
  Select,
  Option,
  Table,
  TableColumn,
  InputNumber,
} from 'element-ui';
import {
  log,
} from 'util';
import ObjectUtil from '@/libs/ObjectUtil';
import api from '@/api/app';
import examApi from '@/api/exam';
import {
  COMMON_DATA_TYPE,
  ExamTypeEnum,
} from '@/libs/config';
import addOrModifyCommon from '../../../../components/common/addOrModifyCommon.vue';
@Component({
  components: {
    Dialog,
    Button,
    Row,
    Col,
    addOrModifyCommon,
    Form,
    FormItem,
    Input,
    Select,
    Option,
    Table,
    TableColumn,
    InputNumber,
  },
})
export default class addOrModify extends Vue {
  @Ref('paperForm') readonly paperFormView!: Form;

  @Prop() echoData: any;

  @Prop() backCallback!: Function;

  @Watch('echoData')
  onEchoChange(newValue: any, oldValue: any) {
    if (newValue && Object.keys(newValue).length > 0) {
      this.paperForm.id = this.echoData.id;
      this.paperForm.title = this.echoData.title;
      this.paperForm.suggestTime = this.echoData.suggestTime;
      this.paperForm.passingScore = this.echoData.passingScore;
      this.paperForm.description = this.echoData.description;
      examApi.getTestPaperById(this.echoData.id).then((res) => {
        console.log(res)
        if (res && Array.isArray(res)) {
          console.log(res)
          res.forEach((item: any) => {
            // // eslint-disable-next-line no-param-reassign
            // item.radioMaxCount = 0;
            // // eslint-disable-next-line no-param-reassign
            // item.multipleMaxCount = 0;
            // // eslint-disable-next-line no-param-reassign
            // item.judgeMaxCount = 0;
            // console.log(item)
            this.handlerQuesChange(item);
          });
        }
        this.paperForm.questions = res;
        console.log(res)
      });
    } else {
      this.resetForm();
    }
  }

  private richEditor: any = {
    dialogVisible: false,
    object: null,
    parameterName: '',
    instance: null,
  };

  private paperForm: any = {
    title: '',
    type: 'RANDOM_FIXED',
    suggestTime: '',
    passingScore: '',
    paperScore: 0,
    description: '',
    questions: [],
  };

  private title: string = '试卷添加';

  private isNeedAddOrModify = false;

  private isLoading = false;

  private rules: any = {
    title: [{
      required: true,
      message: '请输入试卷名称',
    }],
    suggestTime: [{
      required: true,
      message: '请输入建议时长',
    }],
    passingScore: [{
      required: true,
      message: '请输入及格分数',
    }],
  };

  /**
   * @author: LiuYongChun
   * @description: 计算试卷总分
   * @param {*}
   * @return {*}
   */
  get paperCountScore() {
    let countScore = 0;
    this.paperForm.questions.forEach((item: any) => {
      countScore
        += item.radioCount * item.radioScore
        + item.multipleCount * item.multipleScore
        + item.judgeCount * item.judgeScore;
    });
    this.paperForm.paperScore = countScore;
    return countScore;
  }

  private difficultyType: any = [];

  private questionsType: any = [];

  mounted() {
    api.getBaseDataByType([COMMON_DATA_TYPE.DIFFICULTY]).then((res: any) => {
      this.difficultyType = res.difficulty;
    });
    examApi.getAllQuesBank().then((res: any) => {
      // this.questionsType = res;
      this.questionsType = res.filter((item:any) => {return item.status !== 1})
    });
  }

  /**
   * @author: LiuYongChun
   * @description: 返回至列表
   * @param {*}
   * @return {*}
   */
  back() {
    this.backCallback();
  }

  // 添加子项
  handleAdd() {
    this.paperForm.questions.push({
      radioCount: 0,
      radioMaxCount: 0,
      radioScore: 0,
      multipleCount: 0,
      multipleMaxCount: 0,
      multipleScore: 0,
      judgeCount: 0,
      judgeMaxCount: 0,
      judgeScore: 0,
    });
  }

  // eslint-disable-next-line class-methods-use-this
  handlerQuesChange(questionItem: any) {
    examApi.getQuesDetailCount(questionItem.subjectId).then((res: any) => {
      console.log(res)
      if (res && Array.isArray(res)) {
        res.forEach((item: any) => {
          if (ExamTypeEnum.RADIO === item.value) {
            // eslint-disable-next-line no-param-reassign
            questionItem.radioMaxCount = item.number;
          }
          if (ExamTypeEnum.MULTIPLE === item.value) {
            // eslint-disable-next-line no-param-reassign
            questionItem.multipleMaxCount = item.number;
          }
          if (ExamTypeEnum.JUDGE === item.value) {
            // eslint-disable-next-line no-param-reassign
            questionItem.judgeMaxCount = item.number;
          }
        });
      }
    });
  }

  /**
   * @author: LiuYongChun
   * @description: 移除所选题库
   * @param {*} index
   * @return {*}
   */
  removeItem(index: number) {
    this.paperForm.questions.splice(index, 1);
  }

  /**
   * @author: LiuYongChun
   * @description: 清空添加框
   * @param {*}
   * @return {*}
   */
  resetForm() {
    this.paperFormView.resetFields();
    ObjectUtil.clearValue(this.paperForm);
  }

  /**
   * @author: LiuYongChun
   * @description: 提交试卷
   * @param {*}
   * @return {*}
   */
  submitForm() {
    if (this.checkSubmitData()) {
      this.isLoading = true;

      this.paperForm.type = 'RANDOM_FIXED';
      if (this.paperForm.id) {
        examApi.modifyTestPaper(this.paperForm).then(() => {
          this.resetForm();
          this.back();
          this.isLoading = false;
          /* eslint-disable no-return-assign */
        }).catch(() => (this.isLoading = false));
      } else {
        this.paperForm.id = null;
        examApi.addTestPaper(this.paperForm).then(() => {
          this.resetForm();
          this.back();
          this.isLoading = false;
          /* eslint-disable no-return-assign */
        }).catch(() => (this.isLoading = false));
      }
    }
  }

  /**
   * @author: LiuYongChun
   * @description: 校验提交数据是否均已合格，如果合格则返回true，否则返回false
   * @param {*}
   * @return {*}
   */
  checkSubmitData(): boolean {
    let isPass = false;
    this.paperFormView.validate((isSuccessd: boolean) => {
      isPass = !!(isSuccessd && this.paperForm.questions.length > 0);
    });
    return isPass;
  }

  private inputContent: string = '';

  inputClick(object: any, parameterName: string) {
    this.inputContent = object[parameterName];
    this.richEditor.object = object;
    this.richEditor.parameterName = parameterName;
    this.richEditor.dialogVisible = true;
  }

  editorReady(instance: any) {
    this.richEditor.instance = instance;
    const currentContent = this.richEditor.object[this.richEditor.parameterName];
    this.richEditor.instance.setContent(currentContent);
    // 光标定位到Ueditor
    this.richEditor.instance.focus(true);
  }

  showOrCloseAdd() {
    this.richEditor.dialogVisible = true;
    this.isNeedAddOrModify = !this.isNeedAddOrModify;
  }

  editorConfirm() {
    const content = this.richEditor.instance.getContent();
    this.richEditor.object[this.richEditor.parameterName] = content;
    this.richEditor.dialogVisible = false;
  }
}
